export default __webpack_public_path__ + "static/media/Olim3.a23b3af4.png";